import { Range } from '@shopify/polaris';
import { add } from 'date-fns';

export const SOONER_START_DATE = process.env
  .NEXT_PUBLIC_MATCHING_SOONER_TIMEFRAME_DAYS_START
  ? parseInt(process.env.NEXT_PUBLIC_MATCHING_SOONER_TIMEFRAME_DAYS_START, 10)
  : 2;

export const SOONER_END_DATE = process.env.MATCHING_SOONER_TIMEFRAME_DAYS_END
  ? parseInt(process.env.MATCHING_SOONER_TIMEFRAME_DAYS_END, 10)
  : 17;

export const LATER_END_DATE = process.env.MATCHING_LATER_TIMEFRAME_DAYS_END
  ? parseInt(process.env.MATCHING_LATER_TIMEFRAME_DAYS_END, 10)
  : 28;

export const getDateRangeForProviderTimeslots = (): Range => {
  const today = new Date();
  const startTimeFromToday = add(today, {
    days: SOONER_START_DATE,
  });
  const endTimeFromToday = add(today, {
    days: LATER_END_DATE,
  });
  return { start: startTimeFromToday, end: endTimeFromToday } as Range;
};
